// extracted by mini-css-extract-plugin
module.exports =  {"styledModal":"ModalLarge-module__styledModal--fkxKU","content":"ModalLarge-module__content--DTuvG"};